import { SvgIconProps } from '@mui/material';

export const FaceSadIcon = (props: SvgIconProps) => {
  return (
    <svg {...props} fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4979_5181)">
        <path
          d="M13.3334 13.3332C13.3334 13.3332 12.0834 11.6665 10 11.6665C7.91669 11.6665 6.66669 13.3332 6.66669 13.3332M14.1667 7.69984C13.8375 8.104 13.3875 8.33317 12.9167 8.33317C12.4459 8.33317 12.0084 8.104 11.6667 7.69984M8.33335 7.69984C8.00419 8.104 7.55419 8.33317 7.08335 8.33317C6.61252 8.33317 6.17502 8.104 5.83335 7.69984M18.3334 9.99984C18.3334 14.6022 14.6024 18.3332 10 18.3332C5.39765 18.3332 1.66669 14.6022 1.66669 9.99984C1.66669 5.39746 5.39765 1.6665 10 1.6665C14.6024 1.6665 18.3334 5.39746 18.3334 9.99984Z"
          stroke="#344054"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.67"
        />
      </g>
      <defs>
        <clipPath id="clip0_4979_5181">
          <rect fill="white" height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
};
